export default class GlobalConfig {
 static IsUltravoxEnabled = true;
}